import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {AuthenticationResponse} from './authentication-response';
import {RestApiService} from '../../http/rest-api.service';
import {AuthApiRoutesEnum} from '../../http/auth-api-routes.enum';
import {Utils} from '@astek/utils';
import {LanguageService} from '../../language/language.service';

@Injectable()
export class LoginRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
    private readonly _languageService: LanguageService,
  ) {
  }

  public requestAuthenticationTokens(login: string, password: string): Observable<AuthenticationResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.LOGIN,
    ].join('/');
    return this._httpClient.post<AuthenticationResponse>(
      url,
      {email: login, password: password, lang: this._languageService.activeLanguage}
    ).pipe(
      tap((response: AuthenticationResponse) => {
        if (Utils.isNotNullOrUndefined(response.accessToken) && Utils.isNotNullOrUndefined(response.preAuthToken)) {
          throw new Error('Authentication failed');
        }
      }),
    );
  }

  public request2FACheck(otp: string): Observable<AuthenticationResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.TWO_FA_CHECK,
    ].join('/');
    return this._httpClient.post<AuthenticationResponse>(url, {'code': otp});
  }

  public requestResend2FACode(): Observable<AuthenticationResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.TWO_FA_CHECK,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams({lang: this._languageService.activeLanguage});
    return this._httpClient.get<AuthenticationResponse>(url, {params: params});
  }
}
